import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { Chip, Grid } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ContainedButton } from 'styles/styles';

import { MfaListItem, MfaListMethodDescription, MfaListMethodTitle } from './styles';

export interface MfaMethodProps {
  name: React.ReactNode;
  description: React.ReactNode;
  icon: FontAwesomeIconProps['icon'];
  isEnabled: boolean;
  onEdit: () => void;
  onDisable: () => void;
}

export default function MfaMethod(props: MfaMethodProps) {
  const {
    icon,
    description,
    name,
    isEnabled,
    onEdit,
    onDisable,
  } = props;

  return (
    <MfaListItem item>
      <Grid container flexDirection="row" justifyContent="space-between" alignContent="center">
        <Grid item>
          <Grid container flexDirection="row" alignItems="center" gap={2}>
            <Grid item>
              <FontAwesomeIcon icon={icon} size="2x" />
            </Grid>
            <Grid item>
              <Grid container flexDirection="column">
                <Grid item>
                  <Grid container flexDirection="row" alignItems="center" gap={2}>
                    <Grid item>
                      <MfaListMethodTitle>
                        {name}
                      </MfaListMethodTitle>
                    </Grid>
                    {isEnabled && (
                      <Grid item>
                        <Chip
                          color="success"
                          label={<FormattedMessage id="mfa_enabled" />}
                        />
                      </Grid>
                    )}
                  </Grid>
                </Grid>
                <Grid item>
                  <MfaListMethodDescription>
                    {description}
                  </MfaListMethodDescription>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          {isEnabled ? (
            <ContainedButton onClick={onDisable} color="secondary">
              <FormattedMessage id="mfa_disable" />
            </ContainedButton>
          ) : (
            <ContainedButton onClick={onEdit} color="secondary">
              <FormattedMessage id="mfa_edit" />
            </ContainedButton>
          )}
        </Grid>
      </Grid>
    </MfaListItem>
  );
}
